var _excluded = ["a11yTitle"],
  _excluded2 = ["size", "variant", "colorScheme", "disabled", "onClick", "children", "LeftIcon", "RightIcon", "tabIndex", "fit", "name", "value", "className", "type", "waitingOptions", "wait", "adaptive"],
  _excluded3 = ["item", "readonly", "onClick", "size"],
  _excluded4 = ["items", "readonly", "size", "onClick", "onClearAll", "withClearAllTag"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import { jsx as i, jsxs as w } from "react/jsx-runtime";
import { createGlobalStyle as Q, styled as l, css as o } from "styled-components";
import { forwardRef as V, useMemo as D, useCallback as X } from "react";
var z = {
    button: {
      color: {
        primary: {
          accent: {
            bg: {
              color: {
                default: "#00a6ee",
                hover: "#0091df",
                focus: "#0091df",
                disabled: "#bfc7d1"
              }
            },
            label: {
              color: {
                default: "#ffffff",
                hover: "#ffffff",
                focus: "#ffffff",
                disabled: "#ffffff"
              }
            },
            icon: {
              color: {
                default: "#ffffff",
                hover: "#ffffff",
                focus: "#ffffff",
                disabled: "#ffffff"
              }
            }
          },
          accentContrast: {
            bg: {
              color: {
                default: "#0060e1",
                hover: "#004bd6",
                focus: "#004bd6",
                disabled: "#bfc7d1"
              }
            },
            label: {
              color: {
                default: "#ffffff",
                hover: "#ffffff",
                focus: "#ffffff",
                disabled: "#ffffff"
              }
            },
            icon: {
              color: {
                default: "#ffffff",
                hover: "#ffffff",
                focus: "#ffffff",
                disabled: "#ffffff"
              }
            }
          },
          alternative: {
            bg: {
              color: {
                default: "#8131cc",
                hover: "#6f00c4",
                focus: "#6f00c4",
                disabled: "#bfc7d1"
              }
            },
            label: {
              color: {
                default: "#ffffff",
                hover: "#ffffff",
                focus: "#ffffff",
                disabled: "#ffffff"
              }
            },
            icon: {
              color: {
                default: "#ffffff",
                hover: "#ffffff",
                focus: "#ffffff",
                disabled: "#ffffff"
              }
            }
          }
        },
        secondary: {
          accent: {
            bg: {
              color: {
                default: "#daf4ff",
                hover: "#b7e8ff",
                focus: "#b7e8ff",
                disabled: "#bfc7d1"
              }
            },
            label: {
              color: {
                default: "#0091df",
                hover: "#005fab",
                focus: "#005fab",
                disabled: "#ffffff"
              }
            },
            icon: {
              color: {
                default: "#0091df",
                hover: "#005fab",
                focus: "#005fab",
                disabled: "#ffffff"
              }
            }
          },
          accentContrast: {
            bg: {
              color: {
                default: "#e4f0ff",
                hover: "#cee1ff",
                focus: "#cee1ff",
                disabled: "#bfc7d1"
              }
            },
            label: {
              color: {
                default: "#004bd6",
                hover: "#0028ad",
                focus: "#0028ad",
                disabled: "#ffffff"
              }
            },
            icon: {
              color: {
                default: "#004bd6",
                hover: "#0028ad",
                focus: "#0028ad",
                disabled: "#ffffff"
              }
            }
          },
          alternative: {
            bg: {
              color: {
                default: "#f8edff",
                hover: "#f0dbfe",
                focus: "#f0dbfe",
                disabled: "#bfc7d1"
              }
            },
            label: {
              color: {
                default: "#6f00c4",
                hover: "#4a008c",
                focus: "#4a008c",
                disabled: "#ffffff"
              }
            },
            icon: {
              color: {
                default: "#6f00c4",
                hover: "#4a008c",
                focus: "#4a008c",
                disabled: "#ffffff"
              }
            }
          }
        },
        text: {
          accent: {
            bg: {
              color: {
                default: "rgba(255, 255, 255, 0)",
                hover: "rgba(255, 255, 255, 0)",
                focus: "rgba(255, 255, 255, 0)",
                disabled: "rgba(255, 255, 255, 0)"
              }
            },
            label: {
              color: {
                default: "#0091df",
                hover: "#005fab",
                focus: "#005fab",
                disabled: "#a2acb7"
              }
            },
            icon: {
              color: {
                default: "#0091df",
                hover: "#005fab",
                focus: "#005fab",
                disabled: "#a2acb7"
              }
            }
          },
          accentContrast: {
            bg: {
              color: {
                default: "rgba(255, 255, 255, 0)",
                hover: "rgba(255, 255, 255, 0)",
                focus: "rgba(255, 255, 255, 0)",
                disabled: "rgba(255, 255, 255, 0)"
              }
            },
            label: {
              color: {
                default: "#004bd6",
                hover: "#0028ad",
                focus: "#0028ad",
                disabled: "#a2acb7"
              }
            },
            icon: {
              color: {
                default: "#004bd6",
                hover: "#0028ad",
                focus: "#0028ad",
                disabled: "#a2acb7"
              }
            }
          },
          alternative: {
            bg: {
              color: {
                default: "rgba(255, 255, 255, 0)",
                hover: "rgba(255, 255, 255, 0)",
                focus: "rgba(255, 255, 255, 0)",
                disabled: "rgba(255, 255, 255, 0)"
              }
            },
            label: {
              color: {
                default: "#6f00c4",
                hover: "#4a008c",
                focus: "#4a008c",
                disabled: "#a2acb7"
              }
            },
            icon: {
              color: {
                default: "#6f00c4",
                hover: "#4a008c",
                focus: "#4a008c",
                disabled: "#a2acb7"
              }
            }
          }
        },
        inverse: {
          accent: {
            bg: {
              color: {
                default: "#ffffff",
                hover: "#ffffff",
                focus: "#ffffff",
                disabled: "#ffffff"
              }
            },
            label: {
              color: {
                default: "#0091df",
                hover: "#005fab",
                focus: "#005fab",
                disabled: "#a2acb7"
              }
            },
            icon: {
              color: {
                default: "#0091df",
                hover: "#005fab",
                focus: "#005fab",
                disabled: "#a2acb7"
              }
            }
          },
          accentContrast: {
            bg: {
              color: {
                default: "#ffffff",
                hover: "#ffffff",
                focus: "#ffffff",
                disabled: "#ffffff"
              }
            },
            label: {
              color: {
                default: "#004bd6",
                hover: "#0028ad",
                focus: "#0028ad",
                disabled: "#a2acb7"
              }
            },
            icon: {
              color: {
                default: "#004bd6",
                hover: "#0028ad",
                focus: "#0028ad",
                disabled: "#a2acb7"
              }
            }
          },
          alternative: {
            bg: {
              color: {
                default: "#ffffff",
                hover: "#ffffff",
                focus: "#ffffff",
                disabled: "#ffffff"
              }
            },
            label: {
              color: {
                default: "#6f00c4",
                hover: "#4a008c",
                focus: "#4a008c",
                disabled: "#a2acb7"
              }
            },
            icon: {
              color: {
                default: "#6f00c4",
                hover: "#4a008c",
                focus: "#4a008c",
                disabled: "#a2acb7"
              }
            }
          }
        }
      }
    },
    focus: {
      accent: {
        color: "#74cfff"
      },
      accentContrast: {
        color: "#4790f9"
      },
      alternative: {
        color: "#b573ec"
      }
    },
    tagline: {
      color: {
        oneLine: {
          bg: {
            color: "#daf4ff"
          },
          outline: {
            color: "#74cfff"
          },
          title: {
            color: "#0091df"
          },
          icon: {
            color: {
              default: "#0091df",
              hover: "#005fab"
            }
          }
        },
        twoLines: {
          bg: {
            color: "#daf4ff"
          },
          outline: {
            color: "#74cfff"
          },
          title: {
            color: "#0091df"
          },
          subtitle: {
            color: "#0091df"
          },
          icon: {
            color: {
              default: "#0091df",
              hover: "#005fab"
            }
          }
        }
      }
    }
  },
  F = {
    button: {
      size: {
        xl: {
          variant: {
            primary: {
              borderRadius: "12px",
              height: "64px",
              paddingLeft: "40px",
              paddingRight: "40px"
            },
            secondary: {
              borderRadius: "12px",
              height: "64px",
              paddingLeft: "40px",
              paddingRight: "40px"
            },
            inverse: {
              borderRadius: "12px",
              height: "64px",
              paddingLeft: "40px",
              paddingRight: "40px"
            },
            text: {
              borderRadius: "3px",
              height: "32px",
              paddingLeft: "0",
              paddingRight: "0"
            }
          },
          common: {
            spacing: "8px",
            icon: {
              width: "32px",
              height: "32px"
            }
          }
        },
        l: {
          variant: {
            primary: {
              borderRadius: "8px",
              height: "56px",
              paddingLeft: "32px",
              paddingRight: "32px"
            },
            secondary: {
              borderRadius: "8px",
              height: "56px",
              paddingLeft: "32px",
              paddingRight: "32px"
            },
            inverse: {
              borderRadius: "8px",
              height: "56px",
              paddingLeft: "32px",
              paddingRight: "32px"
            },
            text: {
              borderRadius: "3px",
              height: "26px",
              paddingLeft: "0",
              paddingRight: "0"
            }
          },
          common: {
            spacing: "8px",
            icon: {
              width: "26px",
              height: "26px"
            }
          }
        },
        m: {
          variant: {
            primary: {
              borderRadius: "8px",
              height: "48px",
              paddingLeft: "24px",
              paddingRight: "24px"
            },
            secondary: {
              borderRadius: "8px",
              height: "48px",
              paddingLeft: "24px",
              paddingRight: "24px"
            },
            inverse: {
              borderRadius: "8px",
              height: "48px",
              paddingLeft: "24px",
              paddingRight: "24px"
            },
            text: {
              borderRadius: "3px",
              height: "24px",
              paddingLeft: "0",
              paddingRight: "0"
            }
          },
          common: {
            spacing: "8px",
            icon: {
              width: "24px",
              height: "24px"
            }
          }
        },
        s: {
          variant: {
            primary: {
              borderRadius: "6px",
              height: "40px",
              paddingLeft: "20px",
              paddingRight: "20px"
            },
            secondary: {
              borderRadius: "6px",
              height: "40px",
              paddingLeft: "20px",
              paddingRight: "20px"
            },
            inverse: {
              borderRadius: "6px",
              height: "40px",
              paddingLeft: "20px",
              paddingRight: "20px"
            },
            text: {
              borderRadius: "3px",
              height: "16px",
              paddingLeft: "0",
              paddingRight: "0"
            }
          },
          common: {
            spacing: "4px",
            icon: {
              width: "16px",
              height: "16px"
            }
          }
        },
        xs: {
          variant: {
            primary: {
              borderRadius: "6px",
              height: "32px",
              paddingLeft: "16px",
              paddingRight: "16px"
            },
            secondary: {
              borderRadius: "6px",
              height: "32px",
              paddingLeft: "16px",
              paddingRight: "16px"
            },
            inverse: {
              borderRadius: "6px",
              height: "32px",
              paddingLeft: "16px",
              paddingRight: "16px"
            },
            text: {
              borderRadius: "3px",
              height: "12px",
              paddingLeft: "0",
              paddingRight: "0"
            }
          },
          common: {
            spacing: "4px",
            icon: {
              width: "12px",
              height: "12px"
            }
          }
        }
      }
    },
    tagline: {
      size: {
        s: {
          oneLine: {
            gap: "8px",
            outline: {
              width: "3px"
            },
            paddingLeft: "8px",
            paddingRight: "8px",
            paddingTop: "2px",
            paddingBottom: "2px",
            spaceBetween: "8px",
            titleSubtitle: {
              gap: "0"
            },
            icon: {
              width: "16px",
              height: "16px"
            },
            borderRadius: "9999px"
          },
          twoLines: {
            icon: {
              width: "16px",
              height: "16px"
            },
            paddingLeft: "16px",
            paddingRight: "16px",
            paddingTop: "8px",
            paddingBottom: "8px",
            gap: "8px",
            spaceBetween: "8px",
            titleSubtitle: {
              gap: "0"
            },
            borderRadius: "16px",
            outline: {
              width: "3px"
            }
          }
        }
      }
    }
  },
  $ = {
    font: {
      family: {
        base: "'Noto Sans', Arial, sans-serif"
      }
    },
    button: {
      font: {
        size: {
          xl: {
            label: {
              fontSize: "20px",
              lineHeight: "32px"
            }
          },
          l: {
            label: {
              fontSize: "18px",
              lineHeight: "24px"
            }
          },
          m: {
            label: {
              fontSize: "16px",
              lineHeight: "24px"
            }
          },
          s: {
            label: {
              fontSize: "14px",
              lineHeight: "22px"
            }
          },
          xs: {
            label: {
              fontSize: "12px",
              lineHeight: "16px"
            }
          }
        },
        common: {
          label: {
            fontFamily: "'Noto Sans', Arial, sans-serif",
            fontWeight: "700",
            letterSpacing: "0"
          }
        }
      }
    },
    tagline: {
      font: {
        s: {
          oneLine: {
            title: {
              fontFamily: "'Noto Sans', Arial, sans-serif",
              fontSize: "13px",
              fontWeight: "700",
              lineHeight: "20px",
              letterSpacing: "0.1px"
            }
          },
          twoLines: {
            title: {
              fontFamily: "'Noto Sans', Arial, sans-serif",
              fontSize: "13px",
              fontWeight: "700",
              lineHeight: "20px",
              letterSpacing: "0.1px"
            },
            subtitle: {
              fontFamily: "'Noto Sans', Arial, sans-serif",
              fontSize: "13px",
              fontWeight: "400",
              lineHeight: "20px",
              letterSpacing: "0.1px"
            }
          }
        }
      }
    }
  },
  Y = {
    blue99: "#f3fdff",
    blue95: "#daf4ff",
    blue90: "#b7e8ff",
    blue80: "#74cfff",
    blue70: "#18b7f7",
    blue60: "#00a6ee",
    blue40: "#0078c1",
    blue50: "#0091df",
    blue30: "#005fab",
    blue20: "#00478c",
    blue10: "#00366c",
    darkBlue99: "#f7fcff",
    darkBlue95: "#e4f0ff",
    darkBlue90: "#cee1ff",
    darkBlue80: "#a8c5ff",
    darkBlue70: "#7daaff",
    darkBlue60: "#4790f9",
    darkBlue50: "#0077ed",
    darkBlue40: "#0060e1",
    darkBlue30: "#004bd6",
    darkBlue20: "#0038c1",
    darkBlue10: "#0028ad",
    transparent: "rgba(255, 255, 255, 0)",
    black100: "#ffffff",
    black99: "#f8f9fa",
    black95: "#eef1f4",
    black90: "#dde3ea",
    black80: "#bfc7d1",
    black70: "#a2acb7",
    black60: "#87929e",
    black50: "#6c7886",
    black40: "#52606e",
    black30: "#394857",
    black20: "#213241",
    black10: "#081d2d",
    green99: "#d1ffe6",
    green95: "#99f7c4",
    green90: "#7cecb0",
    green80: "#59d994",
    green70: "#4ac684",
    green60: "#33b36e",
    green50: "#289f5e",
    green40: "#268b54",
    green30: "#11703c",
    green20: "#065128",
    green10: "#00381a",
    yellow99: "#fffad5",
    yellow95: "#ffec8f",
    yellow90: "#ffdd6d",
    yellow80: "#ffd240",
    yellow70: "#ffc710",
    yellow60: "#ffa903",
    yellow50: "#f4890a",
    yellow40: "#e16105",
    yellow30: "#ac4a03",
    yellow20: "#7a3503",
    yellow10: "#4e2202",
    red99: "#fff6f9",
    red95: "#ffe3eb",
    red90: "#ffcedb",
    red80: "#ffaabc",
    red70: "#ff859f",
    red60: "#f05e83",
    red50: "#de2d68",
    red40: "#cb004e",
    red30: "#b60041",
    red20: "#9a0034",
    red10: "#7f0020",
    purple99: "#fefbff",
    purple95: "#f8edff",
    purple90: "#f0dbfe",
    purple80: "#e0b7fd",
    purple70: "#cd93fb",
    purple60: "#b573ec",
    purple50: "#9b53dc",
    purple40: "#8131cc",
    purple30: "#6f00c4",
    purple20: "#5a00a4",
    purple10: "#4a008c"
  },
  ee = _objectSpread(_objectSpread({}, Y), {}, {
    icon: "#0091DF"
  }),
  te = {
    size: {
      10: "10px",
      12: "12px",
      14: "14px",
      16: "16px",
      20: "20px",
      24: "24px",
      26: "26px",
      32: "32px",
      40: "40px",
      48: "48px"
    }
  },
  y = {
    desktop: "1440px",
    tablet: "1080px",
    tabletMd: "1024px",
    tabletSm: "768px",
    phone: "640px",
    phoneSm: "320px"
  },
  ie = ["phoneSm", "phone", "tabletSm", "tabletMd", "tablet", "desktop"],
  ne = {
    name: "default",
    colors: ee,
    icons: te,
    zIndex: {
      modal: 1080,
      tooltip: 999,
      datePicker: 959,
      toast: 9999,
      header: {
        overlay: 1060,
        menu: 1062,
        container: 1061
      },
      sticky: 1062
    },
    fontFamily: $.font.family.base,
    up: function up(e) {
      return "@media (min-width: ".concat(y[e], ")");
    },
    down: function down(e) {
      return "@media (max-width: ".concat(y[e], ")");
    },
    between: function between(e, t) {
      return "@media (min-width: ".concat(y[e], ") and (max-width: ").concat(y[t], ")");
    }
  },
  oe = function oe(e, t) {
    return t in e.colors;
  },
  ae = "/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button}button::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner{border-style:none;padding:0}button:-moz-focusring,[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}";
Q(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n\n  img {\n    max-width: 100%;\n    height: auto;\n    object-fit: contain;\n  }\n\n  body {\n    min-width: ", ";\n  }\n\n  body,\n  button,\n  input {\n    font-family: ", ";\n    color: ", ";\n  }\n  p,\n  a,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  input,\n  hr,\n  button,\n  section,\n  menu {\n    margin: 0;\n    padding: 0;\n  }\n  div,\n  section,\n  input,\n  button {\n    box-sizing: border-box;\n  }\n  input {\n    outline: none;\n  }\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  textarea:-webkit-autofill,\n  textarea:-webkit-autofill:hover,\n  textarea:-webkit-autofill:focus,\n  select:-webkit-autofill,\n  select:-webkit-autofill:hover,\n  select:-webkit-autofill:focus {\n    transition: background-color 100s ease-in-out 0s;\n  }\n  button {\n    border: none;\n  }\n"])), ae, y.phoneSm, function (_ref) {
  var e = _ref.theme;
  return e.fontFamily;
}, function (_ref2) {
  var e = _ref2.theme;
  return e.colors.black10;
});
var fe = l.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  min-height: 16px;\n  font-size: 13px;\n"])));
l.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
l.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 1;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  white-space: nowrap;\n  margin: 0;\n"])));
l.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
l(fe)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n  margin-top: 8px;\n  min-height: 1em;\n  font-size: 16px;\n"])));
l.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
l.p(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  line-height: 1;\n  letter-spacing: 0.1px;\n  color: ", ";\n"])), function (_ref3) {
  var e = _ref3.theme;
  return e.colors.red50;
});
o(["font-family:inherit;font-weight:400;font-size:16px;line-height:22px;", "{font-size:14px;}"], function (_ref4) {
  var e = _ref4.theme.down;
  return e("tablet");
});
var I = "0px 1px 8px rgba(0, 0, 0, 0.17)",
  N = "0px 4px 20px rgba(0, 0, 0, 0.07)",
  H = "0px 4px 28px rgba(0, 0, 0, 0.14)";
o(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], I);
o(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], N);
o(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], H);
o(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], I);
o(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], N);
o(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], H);
l.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  width: 1px;\n  height: 0px;\n  padding: 0;\n  overflow: hidden;\n  position: fixed;\n  top: 1px;\n  left: 1px;\n"])));
var le = o(["", ";g{fill:inherit;stroke:inherit;}*:not([stroke]){&[fill='none']{stroke-width:0;}}*[stroke*='#'],*[STROKE*='#']{stroke:inherit;fill:none;}*[fill-rule],*[FILL-RULE],*[fill*='#'],*[FILL*='#']{stroke:none;}*[fill-rule],*[FILL-RULE],*[fill*='#']:not([fill='#FFF']),*[FILL*='#']:not([FILL='#FFF']){fill:inherit;}"], function (_ref5) {
    var _t$colors$n;
    var e = _ref5.color,
      t = _ref5.theme,
      n = _ref5.disabled;
    var a;
    return n ? a = typeof n == "string" ? (_t$colors$n = t.colors[n]) !== null && _t$colors$n !== void 0 ? _t$colors$n : n : t.colors.black80 : e && oe(t, e) ? a = t.colors[e] : a = e || t.colors.icon, o(["fill:", ";stroke:", ";"], a, a);
  }),
  v = 24,
  re = function re(e) {
    var t = e.match(/\d+(\.\d+)?/);
    return t ? parseFloat(t[0]) : v;
  },
  de = l.svg(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: inline-block;\n  flex: 0 0 auto;\n  ", "\n  ", ";\n"])), function (_ref6) {
    var _ref6$size = _ref6.size,
      e = _ref6$size === void 0 ? v : _ref6$size,
      t = _ref6.theme,
      n = _ref6.viewBox;
    var _split = (n || "0 0 ".concat(v, " ").concat(v)).split(" "),
      _split2 = _slicedToArray(_split, 4),
      a = _split2[2],
      s = _split2[3],
      c = +a / +s,
      f = re(t.icons.size[e] || "".concat(e, "px"));
    return a < s ? "\n      width: ".concat(f, "px;\n      height: ").concat(f / c, "px;\n    ") : s < a ? "\n      width: ".concat(f * c, "px;\n      height: ").concat(f, "px;\n    ") : "\n      width: ".concat(f, "px;\n      height: ").concat(f, "px;\n    ");
  }, function (_ref7) {
    var e = _ref7.$hasOwnColorPattern;
    return e ? void 0 : le;
  }),
  A = function A(_ref8) {
    var e = _ref8.a11yTitle,
      t = _objectWithoutProperties(_ref8, _excluded);
    return /* @__PURE__ */i(de, _objectSpread(_objectSpread({}, t), {}, {
      name: e,
      "data-name": "hn-icon"
    }));
  },
  W = function W(e) {
    return /* @__PURE__ */i(A, _objectSpread(_objectSpread({
      viewBox: "0 0 24 24",
      a11yTitle: "Close"
    }, e), {}, {
      children: /* @__PURE__ */i("path", {
        d: "M18.7574 6.25338C18.3391 5.83507 17.6633 5.83507 17.245 6.25338L12 11.4876L6.75505 6.24266C6.33674 5.82435 5.661 5.82435 5.24269 6.24266C4.82438 6.66097 4.82438 7.3367 5.24269 7.75502L10.4877 13L5.24269 18.245C4.82438 18.6633 4.82438 19.339 5.24269 19.7573C5.661 20.1757 6.33674 20.1757 6.75505 19.7573L12 14.5124L17.245 19.7573C17.6633 20.1757 18.3391 20.1757 18.7574 19.7573C19.1757 19.339 19.1757 18.6633 18.7574 18.245L13.5124 13L18.7574 7.75502C19.165 7.34743 19.165 6.66097 18.7574 6.25338Z",
        fill: "#0091DF"
      })
    }));
  };
W.displayName = "Close";
var j = function j(e) {
  return /* @__PURE__ */w(A, _objectSpread(_objectSpread({
    viewBox: "0 0 100 100",
    a11yTitle: "Spinner"
  }, e), {}, {
    children: [/* @__PURE__ */i("g", {
      transform: "rotate(0 50 50)",
      style: {
        animationPlayState: "running",
        animationDelay: "0s"
      },
      children: /* @__PURE__ */i("rect", {
        x: "45.5",
        y: "7.5",
        rx: "2.31",
        ry: "2.31",
        width: "9",
        height: "21",
        fill: "#ffffff",
        style: {
          animationPlayState: "running",
          animationDelay: "0s"
        },
        children: /* @__PURE__ */i("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.875s",
          repeatCount: "indefinite",
          style: {
            animationPlayState: "running",
            animationDelay: "0s"
          }
        })
      })
    }), /* @__PURE__ */i("g", {
      transform: "rotate(45 50 50)",
      style: {
        animationPlayState: "running",
        animationDelay: "0s"
      },
      children: /* @__PURE__ */i("rect", {
        x: "45.5",
        y: "7.5",
        rx: "2.31",
        ry: "2.31",
        width: "9",
        height: "21",
        fill: "#ffffff",
        style: {
          animationPlayState: "running",
          animationDelay: "0s"
        },
        children: /* @__PURE__ */i("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.75s",
          repeatCount: "indefinite",
          style: {
            animationPlayState: "running",
            animationDelay: "0s"
          }
        })
      })
    }), /* @__PURE__ */i("g", {
      transform: "rotate(90 50 50)",
      style: {
        animationPlayState: "running",
        animationDelay: "0s"
      },
      children: /* @__PURE__ */i("rect", {
        x: "45.5",
        y: "7.5",
        rx: "2.31",
        ry: "2.31",
        width: "9",
        height: "21",
        fill: "#ffffff",
        style: {
          animationPlayState: "running",
          animationDelay: "0s"
        },
        children: /* @__PURE__ */i("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.625s",
          repeatCount: "indefinite",
          style: {
            animationPlayState: "running",
            animationDelay: "0s"
          }
        })
      })
    }), /* @__PURE__ */i("g", {
      transform: "rotate(135 50 50)",
      style: {
        animationPlayState: "running",
        animationDelay: "0s"
      },
      children: /* @__PURE__ */i("rect", {
        x: "45.5",
        y: "7.5",
        rx: "2.31",
        ry: "2.31",
        width: "9",
        height: "21",
        fill: "#ffffff",
        style: {
          animationPlayState: "running",
          animationDelay: "0s"
        },
        children: /* @__PURE__ */i("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.5s",
          repeatCount: "indefinite",
          style: {
            animationPlayState: "running",
            animationDelay: "0s"
          }
        })
      })
    }), /* @__PURE__ */i("g", {
      transform: "rotate(180 50 50)",
      style: {
        animationPlayState: "running",
        animationDelay: "0s"
      },
      children: /* @__PURE__ */i("rect", {
        x: "45.5",
        y: "7.5",
        rx: "2.31",
        ry: "2.31",
        width: "9",
        height: "21",
        fill: "#ffffff",
        style: {
          animationPlayState: "running",
          animationDelay: "0s"
        },
        children: /* @__PURE__ */i("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.375s",
          repeatCount: "indefinite",
          style: {
            animationPlayState: "running",
            animationDelay: "0s"
          }
        })
      })
    }), /* @__PURE__ */i("g", {
      transform: "rotate(225 50 50)",
      style: {
        animationPlayState: "running",
        animationDelay: "0s"
      },
      children: /* @__PURE__ */i("rect", {
        x: "45.5",
        y: "7.5",
        rx: "2.31",
        ry: "2.31",
        width: "9",
        height: "21",
        fill: "#ffffff",
        style: {
          animationPlayState: "running",
          animationDelay: "0s"
        },
        children: /* @__PURE__ */i("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.25s",
          repeatCount: "indefinite",
          style: {
            animationPlayState: "running",
            animationDelay: "0s"
          }
        })
      })
    }), /* @__PURE__ */i("g", {
      transform: "rotate(270 50 50)",
      style: {
        animationPlayState: "running",
        animationDelay: "0s"
      },
      children: /* @__PURE__ */i("rect", {
        x: "45.5",
        y: "7.5",
        rx: "2.31",
        ry: "2.31",
        width: "9",
        height: "21",
        fill: "#ffffff",
        style: {
          animationPlayState: "running",
          animationDelay: "0s"
        },
        children: /* @__PURE__ */i("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.125s",
          repeatCount: "indefinite",
          style: {
            animationPlayState: "running",
            animationDelay: "0s"
          }
        })
      })
    }), /* @__PURE__ */i("g", {
      transform: "rotate(315 50 50)",
      style: {
        animationPlayState: "running",
        animationDelay: "0s"
      },
      children: /* @__PURE__ */i("rect", {
        x: "45.5",
        y: "7.5",
        rx: "2.31",
        ry: "2.31",
        width: "9",
        height: "21",
        fill: "#ffffff",
        style: {
          animationPlayState: "running",
          animationDelay: "0s"
        },
        children: /* @__PURE__ */i("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "0s",
          repeatCount: "indefinite",
          style: {
            animationPlayState: "running",
            animationDelay: "0s"
          }
        })
      })
    })]
  }));
};
j.displayName = "Spinner";
var R = z.tagline.color,
  u = F.tagline.size,
  b = $.tagline.font,
  d = z.button.color,
  r = F.button.size,
  g = $.button.font,
  M = {
    xLarge: "xl",
    large: "l",
    medium: "m",
    small: "s",
    xSmall: "xs"
  },
  se = function se(e) {
    return Object.keys(M).includes(e);
  },
  ce = function ce(e) {
    return se(e) ? M[e] : e;
  },
  pe = function pe(_ref9) {
    var e = _ref9.$variant,
      t = _ref9.$size;
    return o(["font-size:", ";line-height:", ";gap:", ";border-radius:", ";padding-left:", ";padding-right:", ";height:", ";[data-name='hn-icon']{width:", ";height:", ";}"], g.size[t].label.fontSize, g.size[t].label.lineHeight, r[t].common.spacing, r[t].variant[e].borderRadius, r[t].variant[e].paddingLeft, r[t].variant[e].paddingRight, r[t].variant[e].height, r[t].common.icon.width, r[t].common.icon.height);
  },
  be = {
    desktop: "m",
    tablet: "m",
    tabletMd: "m",
    tabletSm: "s",
    phone: "s",
    phoneSm: "s"
  },
  ue = function ue(_ref10) {
    var e = _ref10.$variant;
    return o(["", " ", ""], T(e, "phoneSm"), ie.map(function (t) {
      return o(["", "{", "}"], ne.up(t), T(e, t));
    }));
  },
  T = function T(e, t) {
    var n = be[t];
    return o(["font-size:", ";line-height:", ";gap:", ";border-radius:", ";padding-left:", ";padding-right:", ";height:", ";[data-name='hn-icon']{width:", ";height:", ";}"], g.size[n].label.fontSize, g.size[n].label.lineHeight, r[n].common.spacing, r[n].variant[e].borderRadius, r[n].variant[e].paddingLeft, r[n].variant[e].paddingRight, r[n].variant[e].height, r[n].common.icon.width, r[n].common.icon.height);
  },
  ge = function ge(_ref11) {
    var e = _ref11.$variant,
      t = _ref11.$colorScheme;
    return o(["color:", ";background-color:", ";[data-name='hn-icon']{fill:", ";}&:focus-visible{outline:4px solid ", ";color:", ";background-color:", ";[data-name='hn-icon']{fill:", ";}}@media (hover:hover) and (pointer:fine){&:hover{background-color:", ";color:", ";[data-name='hn-icon']{fill:", ";}}}&:disabled{cursor:not-allowed;background-color:", ";color:", ";[data-name='hn-icon']{fill:", ";}}"], d[e][t].label.color.default, d[e][t].bg.color.default, d[e][t].label.color.default, z.focus[t].color, d[e][t].label.color.focus, d[e][t].bg.color.focus, d[e][t].label.color.focus, d[e][t].bg.color.hover, d[e][t].label.color.hover, d[e][t].label.color.hover, d[e][t].bg.color.disabled, d[e][t].label.color.disabled, d[e][t].label.color.disabled);
  },
  he = {
    content: "Please wait...",
    icon: j,
    blockEvents: !0
  },
  xe = l.button(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-width: fit-content;\n  height: fit-content;\n\n  border: none;\n  background-color: transparent;\n\n  cursor: pointer;\n  outline: none;\n  white-space: nowrap;\n  user-select: none;\n\n  font-family: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  text-decoration: none;\n  -webkit-tap-highlight-color: transparent;\n\n  ", ";\n\n  ", ";\n\n  ", "\n"])), g.common.label.fontFamily, g.common.label.fontWeight, g.common.label.letterSpacing, function (_ref12) {
    var e = _ref12.$adaptive,
      t = _ref12.$variant,
      n = _ref12.$colorScheme,
      a = _ref12.$size;
    return o(["", " ", ""], ge({
      $variant: t,
      $colorScheme: n
    }), e ? ue({
      $variant: t
    }) : pe({
      $variant: t,
      $size: a
    }));
  }, function (_ref13) {
    var e = _ref13.$fit;
    return e && o(["width:fit-content;"]);
  }, function (_ref14) {
    var e = _ref14.$wait;
    return e && o(["cursor:wait;"]);
  }),
  me = /*#__PURE__*/V(function (_ref15, Z) {
    var _ref15$size = _ref15.size,
      e = _ref15$size === void 0 ? "m" : _ref15$size,
      _ref15$variant = _ref15.variant,
      t = _ref15$variant === void 0 ? "primary" : _ref15$variant,
      _ref15$colorScheme = _ref15.colorScheme,
      n = _ref15$colorScheme === void 0 ? "accent" : _ref15$colorScheme,
      _ref15$disabled = _ref15.disabled,
      a = _ref15$disabled === void 0 ? !1 : _ref15$disabled,
      s = _ref15.onClick,
      c = _ref15.children,
      f = _ref15.LeftIcon,
      p = _ref15.RightIcon,
      m = _ref15.tabIndex,
      _ref15$fit = _ref15.fit,
      h = _ref15$fit === void 0 ? !1 : _ref15$fit,
      x = _ref15.name,
      U = _ref15.value,
      _ = _ref15.className,
      _ref15$type = _ref15.type,
      G = _ref15$type === void 0 ? "button" : _ref15$type,
      _ref15$waitingOptions = _ref15.waitingOptions,
      B = _ref15$waitingOptions === void 0 ? {} : _ref15$waitingOptions,
      _ref15$wait = _ref15.wait,
      S = _ref15$wait === void 0 ? !1 : _ref15$wait,
      _ref15$adaptive = _ref15.adaptive,
      K = _ref15$adaptive === void 0 ? !1 : _ref15$adaptive,
      J = _objectWithoutProperties(_ref15, _excluded2);
    var k = D(function () {
        var L = _objectSpread(_objectSpread({}, he), B);
        return S ? {
          LeftIcon: L.icon,
          RightIcon: void 0,
          children: L.content,
          onClick: L.blockEvents ? void 0 : s
        } : {
          LeftIcon: f,
          RightIcon: p,
          children: c,
          onClick: s
        };
      }, [f, p, c, s, B, S]),
      q = ce(e);
    return /* @__PURE__ */w(xe, _objectSpread(_objectSpread(_objectSpread({
      $size: q,
      $variant: t,
      $colorScheme: n,
      $wait: S,
      $adaptive: K,
      $fit: h,
      disabled: a,
      tabIndex: m,
      name: x,
      value: U,
      className: _,
      type: G,
      ref: Z
    }, k), J), {}, {
      children: [/* @__PURE__ */i(P, {
        Icon: k.LeftIcon
      }), k.children, /* @__PURE__ */i(P, {
        Icon: k.RightIcon
      })]
    }));
  }),
  ye = l.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n"]))),
  P = function P(_ref16) {
    var e = _ref16.Icon;
    return e ? /* @__PURE__ */i(ye, {
      children: /* @__PURE__ */i(e, {})
    }) : null;
  },
  C = function C(e) {
    return /* @__PURE__ */i(me, _objectSpread(_objectSpread({}, e), {}, {
      variant: "text",
      colorScheme: "accent"
    }));
  };
l(C)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 1;\n\n  ", ";\n"])), function (_ref17) {
  var e = _ref17.theme,
    t = _ref17.$danger;
  return t && o(["color:", ";&:hover,&:focus-visible{color:", ";}"], e.colors.red60, e.colors.red40);
});
var O = l.p(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n"]))),
  E = l.p(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n"]))),
  we = l.figure(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  cursor: default;\n  display: flex;\n  align-items: center;\n  border: none;\n  margin: 0;\n\n  ", "\n"])), function (_ref18) {
    var e = _ref18.$size,
      t = _ref18.$variant;
    return o(["background:", ";padding-bottom:", ";padding-top:", ";padding-left:", ";padding-right:", ";border-radius:", ";gap:", ";", "{color:", ";font-family:", ";font-weight:", ";font-size:", ";line-height:", ";}", "{color:", ";font-family:", ";font-weight:", ";font-size:", ";line-height:", ";}"], R[t].bg.color, u[e][t].paddingBottom, u[e][t].paddingTop, u[e][t].paddingLeft, u[e][t].paddingRight, u[e][t].borderRadius, u[e][t].gap, O, R[t].title.color, b[e][t].title.fontFamily, b[e][t].title.fontWeight, b[e][t].title.fontSize, b[e][t].title.lineHeight, E, R.twoLines.subtitle.color, b[e].twoLines.subtitle.fontFamily, b[e].twoLines.subtitle.fontWeight, b[e].twoLines.subtitle.fontSize, b[e].twoLines.subtitle.lineHeight);
  }),
  ke = l.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral([""]))),
  ve = function ve(_ref19) {
    var e = _ref19.item,
      _ref19$readonly = _ref19.readonly,
      t = _ref19$readonly === void 0 ? !1 : _ref19$readonly,
      n = _ref19.onClick,
      _ref19$size = _ref19.size,
      a = _ref19$size === void 0 ? "s" : _ref19$size,
      s = _objectWithoutProperties(_ref19, _excluded3);
    var c, f, p;
    typeof e == "string" ? f = e : (c = e.id, f = e.label, p = e.subtitle);
    var m = X(function (x) {
      x.preventDefault(), n == null || n(c || f);
    }, [c, f, n]);
    return /* @__PURE__ */w(we, _objectSpread(_objectSpread({}, s), {}, {
      $size: a,
      $variant: p ? "twoLines" : "oneLine",
      children: [/* @__PURE__ */w(ke, {
        children: [/* @__PURE__ */i(O, {
          children: f
        }), p && /* @__PURE__ */i(E, {
          children: p
        })]
      }), !t && /* @__PURE__ */i(C, {
        size: a,
        LeftIcon: W,
        fit: !0,
        onClick: m
      })]
    }));
  },
  Se = l.ul(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n\n  ", "\n"])), function (_ref20) {
    var e = _ref20.$size,
      t = _ref20.$variant;
    return o(["gap:", ";"], u[e][t].spaceBetween);
  }),
  $e = function $e(_ref21) {
    var e = _ref21.items,
      _ref21$readonly = _ref21.readonly,
      t = _ref21$readonly === void 0 ? !1 : _ref21$readonly,
      _ref21$size = _ref21.size,
      n = _ref21$size === void 0 ? "s" : _ref21$size,
      a = _ref21.onClick,
      s = _ref21.onClearAll,
      c = _ref21.withClearAllTag,
      f = _objectWithoutProperties(_ref21, _excluded4);
    var p = c && e.length > 1 && !t,
      m = D(function () {
        return e.some(function (x) {
          return typeof x == "object" && !!x.subtitle;
        }) ? "twoLines" : "oneLine";
      }, [e]);
    return /* @__PURE__ */w(Se, _objectSpread(_objectSpread({}, f), {}, {
      $size: n,
      $variant: m,
      children: [e.map(function (h) {
        return /* @__PURE__ */i("li", {
          children: /* @__PURE__ */i(ve, {
            item: h,
            size: n,
            readonly: t,
            onClick: t ? void 0 : a
          })
        }, JSON.stringify(h));
      }), p && /* @__PURE__ */i("li", {
        children: /* @__PURE__ */i(C, {
          size: n,
          onClick: s,
          fit: !0,
          children: "Clear All"
        })
      })]
    }));
  };
export { ve as Tag, $e as Tags };